<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Schedule Settings</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="jobform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Customer" rules="required">
                                                <v-autocomplete
                                                    v-model="form.customer"
                                                    :items="customers"
                                                    :loading="isLoading"
                                                    :search-input.sync="search"
                                                    hide-no-data
                                                    hide-selected
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Customer"
                                                    placeholder="Start typing to Search"
                                                    prepend-icon="mdi-database-search"
                                                    return-object
                                                    required
                                                    :error-messages="errors"
                                                ></v-autocomplete>
                                            </ValidationProvider>

                                            <ValidationProvider v-slot="{ errors }" name="Cleaner" rules="required">
                                                <v-select
                                                    v-model="form.cleaner"
                                                    :items="cleaners"
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Cleaner"
                                                    required
                                                    :error-messages="errors"
                                                ></v-select>
                                            </ValidationProvider>

                                            <v-menu
                                                v-model="menu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="computedStartDateFormatted"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    label="Start Date"
                                                ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                v-model="form.startdate"
                                                :min="mindate"
                                                @input="menu = false"
                                                ></v-date-picker>
                                            </v-menu>

                                            <ValidationProvider v-slot="{ errors }" name="Renew" rules="required">
                                                <v-select
                                                    v-model="form.renew"
                                                    :items="renewals"
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Renew"
                                                    required
                                                    :error-messages="errors"
                                                ></v-select>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>                        
                        <v-btn large min-width="50%" color="blue darken-1" text to="/schedules">Cancel</v-btn>              
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading" class="mx-0">Update</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'
import moment from 'moment'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['id'],
    data () {
        return {
            customers: [],
            tab: null,
            form: {
                customer: '',
                cleaner: '',
                startdate: new Date().toISOString().substr(0, 10),
                renew: 'weekly',
                status: 'active'
            },
            loading: false,
            isLoading: false,
            search: null,
            mindate: new Date().toISOString().substr(0, 10),
        }
    },
    watch: {
      search (val) {
        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        axios.get('admin/customers/search', {
            params: {
                keyword: val
            }
        })
        .then(response => {
            this.customers = response.data.customers
            this.$nextTick()
        })
        .catch(err => {
            console.log(err)
        })
        .finally(() => (this.isLoading = false))
      },
    },
    computed: {
        ...mapGetters({
            cleaners: 'data/cleaners',
            renewals: 'data/renewals'
        }),
        computedStartDateFormatted () {
            return this.formatDate(this.form.startdate)
        },
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    created() {
        this.getSchedule()
    },
    methods: {
        ...mapActions({
            updateSchedule: 'data/updateSchedule',
        }),
        getSchedule() {
            if(this.id) {
                axios.get('admin/schedule/get?id=' + this.id)
                    .then((response) => {
                        this.form.customer = { label: response.data.job.customer.title, value: response.data.job.customer.id }
                        this.customers.push({...this.form.customer})
                        this.form.cleaner = response.data.job.user.id
                        this.form.startdate = response.data.job.job_start_date
                        this.form.renew = response.data.job.job_interval
                        this.form.status = response.data.job.status
                        this.$nextTick()
                    })
            }
        },
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1 && this.form.startdate != null && this.form.startdate != '') {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateSchedule(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: `/schedules` })
                }).catch(error => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
        formatDate(value){
            if (value) {
                return moment(String(value)).format('MM/DD/YYYY')
            }
        },
    }
}
</script>

<style lang="sass" scoped>
.estimation
    background: #003e72
    color: #fff
    text-align: center
    justify-content: center
    font-size: 20px
    margin: -16px -16px 20px
header
    &.quote-bar
        position: sticky
        top: 0
        z-index: 999
.admin-action 
    background: #1976d2
    button 
        width: 95%
        background: #ffffff
        color: #1976d2
.comment-actions 
    background: #dadada
</style>
<style lang="sass">
.filepond--drop-label
    &.filepond--drop-label label
        margin: 0
        color: #fff
        font-size: 20px
        text-transform: uppercase
        font-size: 16px
        line-height: 1em

.filepond--panel-root
    background: #003a6f
    border-radius: 0
    color: #fff!important
    border: 3px dashed #ffffff

.images
    text-align: center

    img 
        max-width: 100%

.comment-text
    white-space: pre-wrap

.public
    label 
        font-size: 13px

.theme--light
    &.status
        background: #e0f2f5
</style>